export const communityFeedRoutes = {
  list: "",
  postDetails: ":id",
  pollDetails: "polls/:id",
  adminCreatePost: "new",
} as const;
